import ProviderResourceLink from './ProviderResourceLink'
export default ProviderResourceLink
